import { Log } from "@lightningjs/sdk";
import EpgProgram from "./epg-program";
export default class EPGUtility {
    static options = {
        getDeviceCurrentDateTimeFn: undefined
    };

    static setOptions(options: any) {
        EPGUtility.options = options;
    }

    static formatTime(time: Date) {
        //let timeInMS = timeInSeconds * 1000;
        let hrs = time.getHours(); //EPGUtility.getDeviceCurrentDateTime(timeInMS).getHours();
        let mins = time.getMinutes(); //EPGUtility.getDeviceCurrentDateTime(timeInMS).getMinutes();
        let hrsStr = hrs.toString()
        let minsStr = mins.toString()

        if (hrs < 10) {
            hrsStr = "0" + hrs;
        }
        if (mins < 10) {
            minsStr = "0" + mins;
        }
        return `${hrsStr}:${minsStr}:0`;
    }

    static formatAMPM(date: Date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        let strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    static displayToday() {
        const monthName = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        const weekday = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];
        var now = EPGUtility.getDeviceCurrentDateTime();
        var month = now.getMonth();
        var year = now.getFullYear();
        var day = now.getDay();
        var today = now.getDate();
        return weekday[day] + " " + monthName[month] + " " + today;
    }

    static getDeviceCurrentDateTime(_time?: number) {
        const dObj = !_time ? new Date() : new Date(_time);
        if (EPGUtility.options.getDeviceCurrentDateTimeFn) {
            return EPGUtility.options.getDeviceCurrentDateTimeFn(dObj);
        } else {
            return dObj;
        }
    }


    static getProgramPosition(program, range, pixelPerHour, bufferTimeRangeInUI): { x: number, w: number } {
        let x = EPGUtility.getXoffset(program, range, pixelPerHour, bufferTimeRangeInUI)
        let w = EPGUtility.getWidthFromDurationInMinutes(program, pixelPerHour)
        if(x<0) {
            w = w - (Math.abs(x))
            x = 0
        }
        let diff = (pixelPerHour / 60) * bufferTimeRangeInUI
        return { x, w }
    }

    static getWidthFromDurationInMinutes(program, pixelPerHour) {
        return (pixelPerHour / 60) * (program.duration / 60)
    }

    static getCurrentTimelinePosition(range, pixelPerHour, currDate) {
        let min = (currDate - range.startDate) / 1000 / 60
        let xPos = (pixelPerHour / 60) * min
        return xPos
    }

    static getXoffset(program, range, pixelPerHour) {
        let min = (program.start_timeObj - range.startDate) / 1000 / 60 //difference in start position of program and timerange start point.
        let xPos = (pixelPerHour / 60) * min
        return xPos
    }

    static log(msg: string, value = "") {
        Log.info(`[EPG] `, msg, value);
    }

    static isDateInRange(program: EpgProgram | any, range) {
        if (program.start_timeObj < range.endDate && program.end_timeObj > range.startDate) {
            return true
        }
        return false
    }

    static isPlaying(start_timeObj: Date, end_timeObj: Date, currDate: Date):boolean {
        if (start_timeObj <= currDate && end_timeObj >= currDate) {
            return true
        }
        return false
    }

    static getFocusTime(date?:Date) {
        const dt = new Date(date || EPGUtility.getDeviceCurrentDateTime())
        const offsetMin = dt.getMinutes()<30 ? 0:30
        dt.setMinutes(offsetMin,0,0)
        return dt
    }
}

